









import { Component, Vue } from 'vue-property-decorator'
import WelcomeNotary from '@/components/WelcomeNotary.vue'
import EnableTransaction from '@/components/EnableTransaction.vue'
import Logo from '@/components/Logo.vue'
import { getRestoreUser } from '@/api'

@Component({
  name: 'Onboarding',
  components: { WelcomeNotary, EnableTransaction, Logo }
})
export default class Login extends Vue {
  t (key: string) {
    return this.$t(`Onboarding.${key}`)
  }

  restoreCodeErrorCounter = 0
  currentStep = 0
  restoreUser: any = {}
  restoreCode = ''
  created () {
    // console.log(this.$store.getters.currentStep)
  }

  async checkRestoreCode (restoreCode: string) {
    try {
      const restoreUser: any = await getRestoreUser(restoreCode)
      if (!restoreUser) { this.restoreCodeErrorCounter += 1; return }
      this.restoreUser = restoreUser.data
      this.restoreCode = restoreCode
      this.currentStep = 1
    } catch (e) {
      this.restoreCodeErrorCounter += 1
    }
  }
}
